const OriginTooltipContent = () => {
    return (
        <div className="flex flex-col min-h-[160px] sm:w-[450px] md:w-[502px] sm:h-[211px] bg-white rounded-md">
            <div className="px-[32px] pt-[13px] pb-[12px] sm:px-[50px] sm:pt-[38px] sm:pb-[20px]">
                <span className="font-semibold text-base sm:pt-[40px] sm:pb-[20px]">Diamond Origin</span>
            </div>

            <hr className="border-t border-gray-200 w-full" />

            <div className="flex justify-end">
                <span className="text-sm font-normal text-gray-500 px-[32px] pt-[17px] mb-[24px] sm:px-[50px] sm:pt-[24px] sm:mb-[24px]">
                    Discover the full journey, from its mining origin to the final
                    polished gem. Explore detailed insights, including ethical sourcing,
                    craftsmanship, and unique characteristics that make this diamond
                    one-of-a-kind.
                </span>
            </div>
        </div>
    )
}

export default OriginTooltipContent
